import { render, staticRenderFns } from "./limitActivities.vue?vue&type=template&id=37d8e884&scoped=true&"
import script from "./limitActivities.vue?vue&type=script&lang=js&"
export * from "./limitActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d8e884",
  null
  
)

export default component.exports